export const top10Dapps = [
  {
    id: 1,
    title: "We·R2 Casual Game Hub",
    category: "gaming",
    impact: "50,000+ transactions/day en We·R2 Chain",
    priority: "High",
    description: "Plataforma multi-juego casual integrada con recompensas en WR2 Coin, leaderboards y lógica de torneos. Diseñada para generar actividad on-chain de alta frecuencia.",
    incentive: "grantRevenue",
    status: "open"
  },
  {
    id: 2,
    title: "Blonect SocialFi Layer",
    category: "social",
    impact: "Extensión SocialFi de Blonect",
    priority: "Critical",
    description: "Capa social descentralizada construida sobre Blonect, producto nativo de We·R2. Tipping, suscripciones y comunidades token-gated con NFT Access Layer.",
    incentive: "revenueShare",
    status: "open"
  },
  {
    id: 3,
    title: "We·R2 Swap",
    category: "defi",
    impact: "DEX nativo · Liquidez WR2/W2USDT/W2T",
    priority: "Critical",
    description: "Exchange descentralizado de liquidez concentrada con analítica y enrutamiento óptimo. Implementación comunitaria del producto nativo We·R2 Swap.",
    incentive: "strategic",
    status: "open"
  },
  {
    id: 4,
    title: "We·R2 Money Market",
    category: "lending",
    impact: "TVL Target: $10M+ (WR2 / W2T / W2USDT)",
    priority: "High",
    description: "Protocolo de préstamos colateralizados con activos del ecosistema We·R2. Independiente de We·R2 Finance (CEX) — focalizado en DeFi on-chain.",
    incentive: "strategic",
    status: "open"
  },
  {
    id: 5,
    title: "We·R2 Pay",
    category: "payments",
    impact: "Producto nativo — extensiones abiertas",
    priority: "Critical",
    description: "We·R2 Pay ya existe como producto del ecosistema. Abierto a propuestas de extensiones: plugins de pago, integraciones e-commerce, micropagos en W2USDT.",
    incentive: "grantRevenue",
    status: "open"
  },
  {
    id: 6,
    title: "We·R2 NFT Access Layer",
    category: "nft",
    impact: "1M+ NFTs · Integración con Blonect",
    priority: "High",
    description: "NFTs dinámicos para membresías, eventos y control de acceso digital. Integrable con Blonect para comunidades token-gated.",
    incentive: "revenueShare",
    status: "open"
  },
  {
    id: 7,
    title: "We·R2 Quest Engine",
    category: "gamification",
    impact: "100K+ usuarios onboarded (35K waitlist)",
    priority: "High",
    description: "Sistema de misiones on-chain para onboarding y activación del ecosistema. Recompensas en WR2 Coin para los 35,000+ early adopters de la waitlist.",
    incentive: "grant",
    status: "open"
  },
  {
    id: 8,
    title: "BGT Governance Suite",
    category: "governance",
    impact: "BGT Token · 151 Sovereign Nodes",
    priority: "Critical",
    description: "Framework completo de votación y propuestas con BGT, el token de gobernanza de We·R2. Delegación, visibilidad de treasury y validación por Sovereign Nodes.",
    incentive: "strategic",
    status: "open"
  },
  {
    id: 9,
    title: "We·R2 Wallet Security Layer",
    category: "security",
    impact: "Todas las transacciones protegidas",
    priority: "Critical",
    description: "Motor de detección de riesgos on-chain y simulación de transacciones para We·R2 Chain. Integrado con We·R2 Wallet.",
    incentive: "strategic",
    status: "open"
  },
  {
    id: 10,
    title: "Freedom Homes Club",
    category: "rwa",
    impact: "$50M+ activos tokenizados · DMCC",
    priority: "Critical",
    description: "Producto RWA nativo de We·R2 — tokenización de activos inmobiliarios bajo cumplimiento DMCC Dubai. Abierto a extensiones: fraccionalización y mercado secundario.",
    incentive: "strategic",
    status: "open"
  }
];

export const top20Dapps = [
  { id: 11, title: "AI Agent Marketplace", category: "ai", description: "Marketplace descentralizado para agentes IA que operen en We·R2 Chain." },
  { id: 12, title: "Liquid Staking", category: "staking", description: "Liquid staking de WR2 Coin para Sovereign Nodes (117,616 WR2/node)." },
  { id: 13, title: "Payroll Crypto", category: "payroll", description: "Sistema automatizado de nómina e invoicing — pagos en W2USDT + WR2." },
  { id: 14, title: "Cross-chain Swap Hub", category: "crosschain", description: "Agregador multi-chain incluyendo We·R2 Chain (ID 111888)." },
  { id: 15, title: "Data Marketplace", category: "data", description: "Trading y monetización descentralizada de datos en We·R2 Chain." },
  { id: 16, title: "Insurance Protocol", category: "insurance", description: "DeFi insurance para contratos en We·R2 Chain — útil para We·R2 Finance y We·R2 Swap." },
  { id: 17, title: "NFT Royalty Marketplace", category: "nft", description: "Mercado secundario con royalties enforced — integrable con NFT Access Layer." },
  { id: 18, title: "Creator Economy Tools", category: "creator", description: "Herramientas de monetización para creadores — extensión de Blonect." },
  { id: 19, title: "Loyalty Marketplace", category: "loyalty", description: "Intercambio cross-brand de puntos de fidelidad on-chain en We·R2 Chain." },
  { id: 20, title: "Micro-payment Engine", category: "payments", description: "Micropagos sub-céntimo — extensión de We·R2 Pay con W2USDT." },
  { id: 21, title: "Oracle Marketplace", category: "oracle", description: "Red de oráculos descentralizados para We·R2 Chain — crítico para RWA y DeFi." },
  { id: 22, title: "Developer Analytics Suite", category: "analytics", description: "Analytics on-chain para devs — extensión de We·R2 View." },
  { id: 23, title: "No-Code dApp Builder", category: "nocode", description: "Builder visual de smart contracts — extensión de We·R2 BuilderPortal." },
  { id: 24, title: "Referral Tracking Engine", category: "analytics", description: "Tracking on-chain de referidos — útil para onboarding de 35K+ waitlist." },
  { id: 25, title: "Launchpad", category: "launchpad", description: "Plataforma de lanzamiento de tokens — extensión de We·R2 Launch con vesting." },
  { id: 26, title: "Bridge Monitoring Dashboard", category: "bridge", description: "Monitoreo en tiempo real de bridges hacia/desde We·R2 Chain." },
  { id: 27, title: "Carbon Credit Marketplace", category: "carbon", description: "Plataforma de carbon credits tokenizados — complemento RWA verde a Freedom Homes Club." },
  { id: 28, title: "Supply Chain Traceability", category: "supply", description: "Trazabilidad y autenticidad de productos en We·R2 Chain." },
  { id: 29, title: "Tokenized Invoice Platform", category: "invoice", description: "Factoring de facturas on-chain — integrable con We·R2 Pay y We·R2 Finance." },
  { id: 30, title: "DAO-as-a-Service", category: "dao", description: "Creación rápida de DAOs usando BGT — complementa BGT Governance Suite + Sovereign Nodes." }
];

export const allDapps = [...top10Dapps, ...top20Dapps];
